export default "__VITE_ASSET__60c0ef58__"